<template>
	<div style="min-height:500px;">
	    <div class="amountOfStatistical" >
	    	<div class="scroll-div" id="amountOfStatistical" >
	            <div class="tag-defined">
	            	<div class="icon-arrow-left pointer" v-show="statisticScrollLeftShow" @click="scrollLeft('amountOfStatistical')">
		                <i class="el-icon-arrow-left"></i>
		            </div>

			    	<div class="amountOfStatisticalItem">
			    		<div style="color:#008275;">
				    		<div class='amountOfStatisticalItem-right'>
				    			<h2>累计佣金总额（元）</h2>
				    			<p>截止至上次统计的佣金总额</p>
				    			<h1>{{money_format(topData.commissionTotalCount,2)}}</h1>
				    		</div>
				    	</div>
			    	</div>

			    	<div class="amountOfStatisticalItem">
			    		<div style="color:#cc527b;">
				    		<div class='amountOfStatisticalItem-right'>
				    			<h2>本月佣金（元）</h2>
				    			<p>截止至上次统计的本月佣金合计</p>
				    			<h1>{{money_format(topData.commissionMonthCount, 2)}}</h1>
				    		</div>
				    	</div>
			    	</div>

			    	<div class="amountOfStatisticalItem">
			    		<div style="color:#2177a0;">
				    		<div class='amountOfStatisticalItem-right'>
				    			<h2>我的佣金（元）</h2>
				    			<p>截止至上次统计的佣金合计</p>
				    			<h1>{{money_format(topData.myCommission, 2)}}</h1>
				    		</div>
				    	</div>
			    	</div>

			    	<div class="amountOfStatisticalItem">
			    		<div style="color:#7255a7;">
				    		<div class='amountOfStatisticalItem-right'>
				    			<h2>本月订单总额（元）</h2>
				    			<p>截止至上次统计的订单总额合计</p>
				    			<h1>{{money_format(topData.orderMoneyMonthCount, 2)}}</h1>
				    		</div>
				    	</div>
			    	</div>

			    	<div class="amountOfStatisticalItem" style="padding-right: 0px;">
			    		<div style="color:#7680bb;">
				    		<div class='amountOfStatisticalItem-right'>
				    			<h2>我的订单</h2>
				    			<p>截止至上次统计的订单数量合计</p>
				    			<h1>{{number_format(topData.orderMonthCount, 2)}}</h1>
				    		</div>
				    	</div>
			    	</div>

			    	<div class="icon-arrow-right pointer" v-show="statisticScrollRightShow" @click="scrollRight('amountOfStatistical')">
		                <i class="el-icon-arrow-right"></i>
		            </div>
			    </div>
			</div>

	    </div>







	    <div class="cardStatistical">
	    	<div id="cardStatistical">
				<div >
					<div class="icon-arrow-left pointer" style="height: 180px;" v-show="statisticScrollLeftShowSecond" @click="scrollLeftSecond('cardStatistical')">
						<i class="el-icon-arrow-left"></i>
					</div>

					<div class="amountOfStatistical-item">
						<div class="amountOfStatistical-top">
							<h1>SIM卡分销统计（张）</h1>
						</div>
						<div class="amountOfStatistical-bottom">
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.simTotalCount, 2)}}</p>
								<h2>SIM卡总数</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.simAlreadySold, 2)}}</p>
								<h2>已分销卡</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.simNotSold, 2)}}</p>
								<h2>未分销卡</h2>
							</div>
						</div>
					</div>

					<div class="amountOfStatistical-item">
						<div class="amountOfStatistical-top">
							<h1>SIM卡充值统计（张）</h1>
						</div>
						<div class="amountOfStatistical-bottom">
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.simTotalCount, 2)}}</p>
								<h2>SIM卡总数</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.simAlreadyInvest, 2)}}</p>
								<h2>已充值卡</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.simNotInvest, 2)}}</p>
								<h2>未充值卡</h2>
							</div>
						</div>
					</div>
					<div class="amountOfStatistical-item">
						<div class="amountOfStatistical-top">
							<h1>订单统计</h1>
						</div>
						<div class="amountOfStatistical-bottom">
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.orderMonthCount, 2)}}</p>
								<h2>本月订单数</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.backOrderMonthCount, 2)}}</p>
								<h2>本月退款订单数</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.orderUpMonthCount, 2)}}</p>
								<h2>上月订单数</h2>
							</div>
						</div>
					</div>
					<div class="amountOfStatistical-item" style="margin-right:0;">
						<div class="amountOfStatistical-top">
							<h1>订单金额（元）</h1>
						</div>
						<div class="amountOfStatistical-bottom">
							<div class="amountOfStatistical-bottom-item">
								<p>{{money_format(topData.orderMoneyMonthCount, 2)}}</p>
								<h2>本月订单金额</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{money_format(topData.backOrderMoneyMoneyCount, 2)}}</p>
								<h2>本月退款订单金额</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{money_format(topData.orderUpMonthCount, 2)}}</p>
								<h2>上月订单金额</h2>
							</div>
						</div>
					</div>

					<div class="icon-arrow-right pointer" style="height: 180px;" v-show="statisticScrollRightShowSecond" @click="scrollRightSecond('cardStatistical')">
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
	    	</div>

	    </div>




   




	    <div class="bottom-diagram">
	    	<div class="column-diagram">
	    		<div>
		    		<div class="title">
		    			<div class="decorations blue"></div>
		    			<h4>近七日订单</h4>
		    		</div>
		    		<div id="sevenDaysDiagram" class="sevenDaysDiagram"></div>
		    	</div>
	    	</div>
	    	<div class="top-7">
	    		<div class="title">
	    			<div class="decorations blue"></div>
	    			<h4>近七日订单列表</h4>
	    		</div>
	    		<el-table :data="historyTableData" stripe style="width: 100%">
				    <el-table-column
				      prop="orderTime"
				      label="日期"
				      width="180">
				    </el-table-column>
				    <el-table-column
				      prop="weekNumber"
				      label="订单数"
				      width="180">
				    </el-table-column>
				    <el-table-column
				      prop="weekMoney"
				      label="订单金额（元）">
				    </el-table-column>
				</el-table>
	    	</div>
	    </div>

	</div>





</template>

<script>
import {agentDataStatistics, } from '@/api/home.js'
import common from '@/utils/common.js'
const echarts = require('echarts');      // 引入 ECharts 主模块

export default {
    data(){
        return {
        	topData:{},
        	historyData:[],
        	historyTableData:[],


        	orderTime : [], //订单时间
        	weekNumber : [], //订单数
        	weekMoney : [],//订单金额
			maxWeekNumber : 0,//最大订单数
			maxWeekMoney : 0,//最大订单金额

			option : {},
			myChart : {},

			//滚动数据
            scrollValOne: 0,
            statisticScrollLeftShow: false,
            statisticScrollRightShow: false,

            scrollValSecond: 0,
            statisticScrollLeftShowSecond: false,
            statisticScrollRightShowSecond: false,
        }
    },
    methods: {
    	getDataHandle($event){
            agentDataStatistics().then(res => {
                if(res.data.code == 200){
					if(res.data.data){
						this.topData = res.data.data.topData!=null? res.data.data.topData : {} ;
						this.historyData = res.data.data.historyData;

						if(this.historyData != null){
							this.historyTableData = this.historyData.concat().reverse();

							for (let i=0; i<this.historyData.length; i++) {
								this.orderTime.push(this.historyData[i].orderTime);
								this.weekNumber.push(this.historyData[i].weekNumber); 
								this.weekMoney.push(this.historyData[i].weekMoney);
							}
						}
						

						this.maxWeekNumber = this.getMax(this.weekNumber);
						this.maxWeekMoney = this.getMax(this.weekMoney);

						this.option.yAxis[0].max = this.maxWeekNumber;
						this.option.yAxis[1].max = this.maxWeekMoney;

						this.option.series[0].data = this.weekNumber;
						this.option.series[1].data = this.weekMoney;

						this.myChart.setOption(this.option);
					}

                }else{
                    this.$message.error(res.data.msg);
                }
            }).catch(err=>console.error(err));
        },

        //取数组最大值
        getMax(array){
        	var min = array[0], max=array[0];
		    for (let i = 0; i <= array.length; i++) {
		      var cur = array[i];
		      cur > max ? max = cur:null;
		      cur < min ? min = cur:null;
		    }
		    return max;
		},

		scrollLeft(element){
            let w = document.getElementById(element).clientWidth || document.getElementById(element).offsetWidth;

            if(this.scrollValOne >= document.getElementById(element).scrollWidth){
                this.scrollValOne = document.getElementById(element).scrollWidth - w - w/2;
            }
            else if(this.scrollValOne > 0){
                this.scrollValOne = this.scrollValOne - w;
            }

            if(this.scrollValOne <= 0){
                this.scrollValOne = 0;
                this.statisticScrollLeftShow = false;
            }

            document.getElementById(element).scrollTo({ 
                left: this.scrollValOne, 
                behavior: "smooth" 
            });

            this.statisticScrollRightShow = true;
        },

        scrollRight(element){
            let w = document.getElementById(element).clientWidth||document.getElementById(element).offsetWidth;

            if(document.getElementById(element).scrollWidth - this.scrollValOne <= w+w/2){
                this.scrollValOne = document.getElementById(element).scrollWidth;
            }else{
                this.scrollValOne = this.scrollValOne + w/2;
            }

            if(this.scrollValOne >= document.getElementById(element).scrollWidth){
                this.scrollValOne = document.getElementById(element).scrollWidth
                this.statisticScrollRightShow = false;
            }
            
            document.getElementById(element).scrollTo({ 
                left: this.scrollValOne, 
                behavior: "smooth" 
            });
            this.statisticScrollLeftShow = true;
        },



        scrollLeftSecond(element){
            let w = document.getElementById(element).clientWidth || document.getElementById(element).offsetWidth;
            if(this.scrollValSecond >= document.getElementById(element).scrollWidth){
                this.scrollValSecond = document.getElementById(element).scrollWidth - w - w/2;
            }
            else if(this.scrollValSecond > 0){
                this.scrollValSecond = this.scrollValSecond - w;
            }
            if(this.scrollValSecond <= 0){
                this.scrollValSecond = 0;
                this.statisticScrollLeftShowSecond = false;
            }

            document.getElementById(element).scrollTo({ 
                left: this.scrollValSecond, 
                behavior: "smooth" 
            });

            this.statisticScrollRightShowSecond = true;
        },

        scrollRightSecond(element){
            let w = document.getElementById(element).clientWidth||document.getElementById(element).offsetWidth;

            if(document.getElementById(element).scrollWidth - this.scrollValSecond <= w+w/2){
                this.scrollValSecond = document.getElementById(element).scrollWidth;
            }else{
                this.scrollValSecond = this.scrollValSecond + w/2;
            }

            if(this.scrollValSecond >= document.getElementById(element).scrollWidth){
                this.scrollValSecond = document.getElementById(element).scrollWidth
                this.statisticScrollRightShowSecond = false;
            }
            
            document.getElementById(element).scrollTo({ 
                left: this.scrollValSecond, 
                behavior: "smooth" 
            });
            this.statisticScrollLeftShowSecond = true;
        },


		drawDiadram(id){
			var dom = document.getElementById(id);
			this.myChart = echarts.init(dom);
			var app = {};
			app.title = '折柱混合';
			this.option = {
			    tooltip: {
			        trigger: 'axis',
			        axisPointer: {
			            type: 'cross',
			            crossStyle: {
			                color: '#999'
			            }
			        }
			    },
			    toolbox: {
			        feature: {
			            dataView: {show: true, readOnly: false},
			            magicType: {show: true, type:  'bar'},
			            restore: {show: true},
			            saveAsImage: {show: true}
			        }
			    },
			    legend: {
			        data:['订单数','订单金额']
			    },
			    xAxis : [
			        {
			            type: 'category',
			            data: this.orderTime,
			            axisPointer: {
			                type: 'shadow'
			            }
			        }
			    ],
			    yAxis : [
			        {
			            type: 'value',
			            name: '订单数',
			            min: 0,
			            max: this.maxWeekNumber,
			            // interval: 50,
			            axisLabel: {
			                formatter: '{value}'
			            }
			        },
			        {
			            type: 'value',
			            name: '订单金额（元）',
			            min: 0,
			            max: this.maxWeekMoney,
			            // interval: 50,
			            axisLabel: {
			                formatter: '{value}'
			            }
			        }
			    ],
			    series : [
			         {
			            name:'订单数',
			            type:'bar',
			            data:this.weekNumber
			        },
			        {
			            name:'订单金额',
			            type:'bar',
			            yAxisIndex: 1,
			            data:this.weekMoney
			        },
			    ]
			};
		},


		resize(){
			let w = document.getElementById('amountOfStatistical').clientWidth||document.getElementById('amountOfStatistical').offsetWidth;
	        if(document.getElementById('amountOfStatistical').scrollWidth > w){
	        	this.statisticScrollRightShow = true;
				if(this.scrollValOne > 0){
					this.statisticScrollLeftShow = true;
				}				
	        }else{
	        	this.statisticScrollLeftShow = false;
	            this.statisticScrollRightShow = false;
	        }
			

	        let w2 = document.getElementById('cardStatistical').clientWidth||document.getElementById('cardStatistical').offsetWidth;
	        if(document.getElementById('cardStatistical').scrollWidth > w2){
				this.statisticScrollRightShowSecond = true;
				if(this.scrollValSecond > 0){
					this.statisticScrollLeftShowSecond = true;
				}	
	        }else{
	        	this.statisticScrollLeftShowSecond = false;
	            this.statisticScrollRightShowSecond = false;
	        }
		},
        
    },
    created(){
    	this.getDataHandle();
	},

	computed: {
	    
	},

	mounted(){
		this.drawDiadram("sevenDaysDiagram");
		this.resize();

		window.onresize = () => {
            return (() => {
                this.resize();
            })();
        }

	},
}

	

</script>
<style lang="less" scoped>

.amountOfStatistical{
	overflow-y: hidden;
    height: 145px;

	.scroll-div{
		overflow-x: scroll;	

		.tag-defined{
			min-height:145px;
			display: flex;
			justify-content: space-between;


			.amountOfStatisticalItem{
				flex: 1;
				padding-right: 30px;
				>div{
					box-sizing: border-box;
					max-width:350px;
					min-width:260px;
					height:130px;
					border: 1px solid #a9c7d6;
			        background: #f9f9f9;
			        transition: .5s;


					h1{
						font-size:24px;
					}

					h2{
						font-size:18px;
					}

					p{
						font-size:14px;
						color:#8c8c8c;
					}


					.amountOfStatisticalItem-left{
						display:inline-block;
						width:5px;
						height:100%;
						float:left;
						border-radius: 4px 0 0 4px;
					}

					.amountOfStatisticalItem-right{
						display:inline-block;
						height:100%;
						margin-left:25px;

						h2{
							margin-top:15px;
						}

						h2, p{
							margin-bottom:15px;
						}
					}

				}


				>div:hover{
			        border: 1px solid #3490ee;
			        background: #ddf4ff;
			        transition: .5s;
			    }
			}

			.amountOfStatisticalItem:last-child{
				padding-right: 0px;
			}

		}

	}

}





.cardStatistical{
	margin-top: 25px;
	height: 170px;
	overflow-y: hidden;
	
	>div{
		overflow-x: scroll;	
		overflow-y: hidden;
		>div{
			height: 170px;
			display: flex;
			justify-content: space-between;

			.amountOfStatistical-item{
				flex: 1;
				box-sizing: border-box;
				height: 155px;
				margin-top: 15px;
				min-width: 350px;
				max-width: 400px;
				margin-right: 20px;
				border: 1px solid #00a0b5;
				transition: all .3s;


				.amountOfStatistical-top{
					box-sizing: border-box;
					height: 60px;
					border-bottom: 1px solid #00a0b5;

					h1{
						box-sizing: border-box;
						height:60px;
						line-height:60px;
						font-size: 18px;
						margin-left: 30px;
					}
				}


				.amountOfStatistical-bottom-item{
					box-sizing: border-box;
					width: 33.3%;
					height:95px;
					float: left;
					text-align: center;
					font-size: 16px;

					p{
						display: inline-block;
						color:#0085f5;
						height:50px;
						line-height:50px;
					}

					h2{	
						height:45px;
						line-height:45px;
						font-size: 14px;
					}
				}
			}

			.amountOfStatistical-item:last-child{margin-right:0;}

			.amountOfStatistical-item:hover{
				transform: translate(0px,-5px); 
			}
		}

	}
}



.icon-arrow-left, .icon-arrow-right{
	display: inline-block;
	width: 30px;
	line-height: 130px;
	vertical-align: top;
	font-size: 26px;
	text-align: center;
	transition: .5s;
	z-index: 100;
}

.icon-arrow-left:hover, .icon-arrow-right:hover{
	color: #409eff;
	transition: .3s;
}

.icon-arrow-left{
	position: absolute;
	left: 0;
	box-shadow: 10px 0px 10px #fff;
	background: #fff;
}

.icon-arrow-right{
	position: absolute;
	right: 0;
	box-shadow: -10px 0px 10px #fff;
	background: #fff;
}
.pointer{
	cursor: pointer;
}




.bottom-diagram{
	margin-top: 30px;
	min-height:400px;
	display: flex;
	justify-content: space-between;

	.title{
		height:30px;
		margin-bottom: 10px;

		.decorations{
			display:inline-block;
			width: 5px;
			height:30px;
			margin-right: 10px;
			float: left;
		}

		h4{
			display: inline-block;
			height: 30px;
			line-height: 30px;
			clear: both;
		}
	}

	.column-diagram{
		flex: 2;
		min-width: 700px;
		margin-right: 10px;

		>div{
			padding: 10px 20px;
			min-height:380px;
			border: 1px solid #d4d4d4;
			box-shadow: 5px 0px 5px #d4d4d4;
		}
	}

	.top-7{
		box-sizing: border-box;
		flex: 1;
		min-width: 506px;
		padding: 10px 20px;
		min-height:370px;
		border: 1px solid #d4d4d4;
		box-shadow: 5px 0px 5px #d4d4d4, 0px 5px 5px #d4d4d4;

		.sevenDaysDiagram{
			width:750px;
			min-height:370px;
		}
	}
}


.blue{
	background: #2196f3;
}

</style>